<!-- Backdrop overlay -->
@if (isOpen) {
  <div
    class="fixed inset-0 z-[999] bg-black transition-opacity duration-300 ease-in-out"
    [class.opacity-50]="isOpen"
    [class.opacity-0]="!isOpen"
    (click)="closeDialog.emit()"
    (keydown.enter)="closeDialog.emit()"
    (keydown.space)="closeDialog.emit(); $event.preventDefault()"
    role="button"
    tabindex="0"
  ></div>
}

<div
  class="shadow-xl fixed inset-0 z-[1000] flex h-full flex-col overflow-hidden bg-white transition-transform duration-300 ease-in-out md:hidden"
  [class.translate-x-0]="isOpen"
  [class.translate-x-full]="!isOpen"
  [class.pointer-events-none]="!isOpen"
  role="dialog"
  aria-modal="true"
>
  <!-- Header -->
  <div class="flex flex-col items-start bg-secondary-background px-6 py-4">
    <div class="flex w-full items-center justify-between">
      <div class="dium leading-7 text-neutral-800">
        {{ 'components.filter.filters' | translate }}
      </div>
      <button
        class="flex items-center gap-2"
        (click)="closeDialog.emit()"
        type="button"
      >
        <span class="text-base leading-normal font-medium text-neutral-600">
          {{ 'components.filter.close' | translate }}
        </span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.192 6.34424L11.949 10.5862L7.70697 6.34424L6.29297 7.75824L10.535 12.0002L6.29297 16.2422L7.70697 17.6562L11.949 13.4142L16.192 17.6562L17.606 16.2422L13.364 12.0002L17.606 7.75824L16.192 6.34424Z"
            fill="#4A5154"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="flex h-full grow flex-col overflow-auto">
    <!-- Magazine Section -->
    <div class="flex flex-col">
      <div class="h-px bg-neutral-300"></div>
      <div
        class="flex cursor-pointer items-start justify-start gap-2 px-6 py-4 focus:bg-neutral-50 focus:outline-none"
        (click)="toggleSection.emit('magazines')"
        (keydown.enter)="toggleSection.emit('magazines')"
        (keydown.space)="
          toggleSection.emit('magazines'); $event.preventDefault()
        "
        role="button"
        tabindex="0"
      >
        <div class="flex h-7 grow items-center justify-between">
          <div class="text-lg leading-normal font-normal text-primary-text">
            {{ 'components.filter.magazine' | translate }}
          </div>
          <svg
            class="transform transition-transform duration-300 ease-in-out"
            [class.rotate-180]="expandedSections().magazines"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="transition-opacity duration-300 ease-in-out"
              [class.opacity-0]="expandedSections().magazines"
              d="M19 11.5H13V5.5H11V11.5H5V13.5H11V19.5H13V13.5H19V11.5Z"
              fill="#323739"
            />
            <path
              class="transition-opacity duration-300 ease-in-out"
              [class.opacity-100]="expandedSections().magazines"
              [class.opacity-0]="!expandedSections().magazines"
              d="M5 11.5H19V13.5H5V11.5Z"
              fill="#323739"
            />
          </svg>
        </div>
      </div>
      <div
        class="overflow-hidden transition-all duration-300 ease-in-out"
        [style.height]="expandedSections().magazines ? '16rem' : '0'"
        [style.opacity]="expandedSections().magazines ? '1' : '0'"
      >
        <div
          class="h-full overflow-y-auto"
          (scroll)="scrollChange.emit({ event: $event, category: 'magazines' })"
        >
          <div class="flex h-11 items-center justify-between px-6">
            <div class="flex items-center">
              <div
                class="truncate text-base leading-normal font-normal text-primary-text"
              >
                {{ magazinesSelectedCount() }}
                {{ 'components.filter.selected' | translate }}
              </div>
            </div>
            <button
              class="text-base leading-normal font-normal"
              [class.text-orange-500]="magazinesSelectedCount() > 0"
              [class.font-medium]="magazinesSelectedCount() > 0"
              [class.text-neutral-300]="magazinesSelectedCount() === 0"
              [disabled]="magazinesSelectedCount() === 0"
              (click)="clearSelection.emit('magazines')"
            >
              {{ 'components.filter.clearSelection' | translate }}
            </button>
          </div>
          <!-- No Results -->
          @if (!magazines().length) {
            <div class="flex items-center justify-center p-4 text-center">
              <span class="text-sm text-neutral-600">
                {{ 'components.filter.noResults.magazines' | translate }}
              </span>
            </div>
          }
          <div class="flex flex-col">
            @for (magazine of magazines(); track magazine) {
              <dhp-filter-item
                [name]="magazine.name"
                [selected]="magazine.selected"
                [class.font-medium]="magazine.selected"
                [class.bg-neutral-50]="magazine.selected"
                (itemSelected)="
                  toggleSelection.emit({
                    category: 'magazines',
                    item: magazine,
                  })
                "
              ></dhp-filter-item>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Type Section -->
    @if (false) {
      <!-- Temporarily disable type filter because of HOL-1065 -->
      <div class="flex flex-col">
        <div class="h-px bg-neutral-300"></div>
        <div
          class="flex cursor-pointer items-start justify-start gap-2 px-6 py-4 focus:bg-neutral-50 focus:outline-none"
          (click)="toggleSection.emit('types')"
          (keydown.enter)="toggleSection.emit('types')"
          (keydown.space)="toggleSection.emit('types'); $event.preventDefault()"
          role="button"
          tabindex="0"
        >
          <div class="flex h-7 grow items-center justify-between">
            <div class="text-lg leading-normal font-normal text-primary-text">
              {{ 'components.filter.type' | translate }}
            </div>
            <svg
              class="transform transition-transform duration-300 ease-in-out"
              [class.rotate-180]="expandedSections().types"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="transition-opacity duration-300 ease-in-out"
                [class.opacity-0]="expandedSections().types"
                d="M19 11.5H13V5.5H11V11.5H5V13.5H11V19.5H13V13.5H19V11.5Z"
                fill="#323739"
              />
              <path
                class="transition-opacity duration-300 ease-in-out"
                [class.opacity-100]="expandedSections().types"
                [class.opacity-0]="!expandedSections().types"
                d="M5 11.5H19V13.5H5V11.5Z"
                fill="#323739"
              />
            </svg>
          </div>
        </div>
        <div
          class="overflow-hidden transition-all duration-300 ease-in-out"
          [style.height]="expandedSections().types ? '16rem' : '0'"
          [style.opacity]="expandedSections().types ? '1' : '0'"
        >
          <div
            class="h-full overflow-y-auto"
            (scroll)="scrollChange.emit({ event: $event, category: 'types' })"
          >
            <div class="flex h-11 items-center justify-between px-6">
              <div class="flex items-center">
                <div
                  class="truncate text-base leading-normal font-normal text-primary-text"
                >
                  {{ typesSelectedCount() }}
                  {{ 'components.filter.selected' | translate }}
                </div>
              </div>
              <button
                class="text-base leading-normal font-normal"
                [class.text-orange-500]="typesSelectedCount() > 0"
                [class.font-medium]="typesSelectedCount() > 0"
                [class.text-neutral-300]="typesSelectedCount() === 0"
                [disabled]="typesSelectedCount() === 0"
                (click)="clearSelection.emit('types')"
              >
                {{ 'components.filter.clearSelection' | translate }}
              </button>
            </div>
            <!-- No Results -->
            @if (!types().length) {
              <div class="flex items-center justify-center p-4 text-center">
                <span class="text-sm text-neutral-600">
                  {{ 'components.filter.noResults.types' | translate }}
                </span>
              </div>
            }
            <div class="flex flex-col">
              @for (type of types(); track type) {
                <dhp-filter-item
                  [name]="type.name"
                  [selected]="type.selected"
                  [class.font-medium]="type.selected"
                  [class.bg-neutral-50]="type.selected"
                  (itemSelected)="
                    toggleSelection.emit({ category: 'types', item: type })
                  "
                ></dhp-filter-item>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Author Section -->
    <div class="flex flex-col">
      <div class="h-px bg-neutral-300"></div>
      <div
        class="flex cursor-pointer items-start justify-start gap-2 px-6 py-4 focus:bg-neutral-50 focus:outline-none"
        (click)="toggleSection.emit('authors')"
        (keydown.enter)="toggleSection.emit('authors')"
        (keydown.space)="toggleSection.emit('authors'); $event.preventDefault()"
        role="button"
        tabindex="0"
      >
        <div class="flex h-7 grow items-center justify-between">
          <div class="text-lg leading-normal font-normal text-primary-text">
            {{ 'components.filter.author' | translate }}
          </div>
          <svg
            class="transform transition-transform duration-300 ease-in-out"
            [class.rotate-180]="expandedSections().authors"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="transition-opacity duration-300 ease-in-out"
              [class.opacity-0]="expandedSections().authors"
              d="M19 11.5H13V5.5H11V11.5H5V13.5H11V19.5H13V13.5H19V11.5Z"
              fill="#323739"
            />
            <path
              class="transition-opacity duration-300 ease-in-out"
              [class.opacity-100]="expandedSections().authors"
              [class.opacity-0]="!expandedSections().authors"
              d="M5 11.5H19V13.5H5V11.5Z"
              fill="#323739"
            />
          </svg>
        </div>
      </div>
      <div
        class="overflow-hidden transition-all duration-300 ease-in-out"
        [style.height]="
          expandedSections().authors
            ? expandedSections().authors &&
              !expandedSections().magazines &&
              !expandedSections().types
              ? 'calc(100% - 11rem)'
              : '16rem'
            : '0'
        "
        [style.opacity]="expandedSections().authors ? '1' : '0'"
        [style.flex]="
          expandedSections().authors &&
          !expandedSections().magazines &&
          !expandedSections().types
            ? '1 1 auto'
            : 'none'
        "
      >
        <div
          class="h-full overflow-y-auto"
          (scroll)="scrollChange.emit({ event: $event, category: 'authors' })"
        >
          <div class="flex h-11 items-center justify-between px-6">
            <div class="flex items-center">
              <div
                class="truncate text-base leading-normal font-normal text-primary-text"
              >
                {{ authorsSelectedCount() }}
                {{ 'components.filter.selected' | translate }}
              </div>
            </div>
            <button
              class="text-base leading-normal font-normal"
              [class.text-orange-500]="authorsSelectedCount() > 0"
              [class.font-medium]="authorsSelectedCount() > 0"
              [class.text-neutral-300]="authorsSelectedCount() === 0"
              [disabled]="authorsSelectedCount() === 0"
              (click)="clearSelection.emit('authors')"
            >
              {{ 'components.filter.clearSelection' | translate }}
            </button>
          </div>
          <div class="relative mt-4 px-6">
            <div
              class="relative flex h-10 items-center rounded-md border border-neutral-300 pr-2 pl-5"
            >
              <input
                class="flex-1 pr-5 text-base leading-normal font-normal text-neutral-800 outline-none placeholder:text-neutral-500"
                [ngModel]="authorSearchTerm()"
                (ngModelChange)="searchTermChange.emit($event)"
                type="text"
                placeholder="{{ 'components.filter.searchAuthor' | translate }}"
              />
              <!-- Clear button -->
              @if (authorSearchTerm()) {
                <button
                  class="group rounded-full p-1 transition-colors duration-200 hover:bg-neutral-100"
                  (click)="searchTermChange.emit(undefined)"
                  aria-label="Clear search"
                >
                  <svg
                    class="h-4 w-4 text-neutral-500 transition-colors duration-200 group-hover:text-neutral-700"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>
          <!-- No Results -->
          @if (!isLoadingAuthors() && !authors().length) {
            <div class="flex items-center justify-center p-4 text-center">
              <span class="text-sm text-neutral-600">
                {{ 'components.filter.noResults.authors' | translate }}
              </span>
            </div>
          }
          <div class="flex flex-col">
            @for (author of authors(); track trackByAuthorId($index, author)) {
              <dhp-filter-item
                [name]="
                  author.additionalProps
                    ? (author.additionalProps | formatAuthorName)
                    : author.name
                "
                [selected]="author.selected"
                [class.font-medium]="author.selected"
                [class.bg-neutral-50]="author.selected"
                (itemSelected)="
                  toggleSelection.emit({ category: 'authors', item: author })
                "
              ></dhp-filter-item>
            }
          </div>
          @if (isLoadingAuthors()) {
            <div class="flex justify-center py-2">
              <div
                class="h-6 w-6 animate-spin rounded-full border-b-2 border-[#323739]"
              ></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div
    class="flex items-start gap-2 border-t border-neutral-300 px-6 pt-6 pb-8"
  >
    <button
      class="btn-primary btn grow"
      (click)="applyFilters.emit()"
      type="button"
    >
      {{ 'components.filter.showResults' | translate }} ({{ totalArticles() }})
    </button>
    <button class="btn btn-outline" (click)="resetFilters.emit()" type="button">
      {{ 'components.filter.resetFilters' | translate }}
    </button>
  </div>
</div>
